import { SnackbarProvider } from "notistack";
import { ThemeProvider } from "@mui/material/styles";
import { Navigate, RouterProvider, createBrowserRouter } from "react-router-dom";
import Login from "./components/Login/Login";
import Layout from "./components/Layout/Layout";
import "../src/assets/css/theme.css";
import "../src/assets/css/style.css";
import "../src/assets/css/breakpoints.css";
import "../src/assets/css/reusable.css";
import theme from "./theme";
import { useState } from "react";

const App = () => {
  const [userInfo, setUserInfo] = useState("dashboard");
  const [selectedPage, setSelectedPage] = useState("dashboard");
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/dashboard",
      element: (
        <Layout selectedPage={selectedPage} setSelectedPage={setSelectedPage} userInfo={userInfo} setUserInfo={setUserInfo} />
      ),
    },
    {
      path: "*",
      element: <Navigate to="/dashboard" replace />,
    },
  ]);
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <RouterProvider router={router} />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

export default App;
